var exports = {
  "U": "xe533113f--a8d68b--buttons",
};

module.exports = exports;
